




















































































import { Component, Vue } from 'vue-property-decorator';
import Product from '@/interfaces/Product';
import ProductTransaction from '@/interfaces/ProductTransaction';

@Component
export default class Dashboard extends Vue {
  products: Product[];

  productToAdd: string;

  productSelected: ProductTransaction;

  showSnackbar: boolean;

  snackbarMessage: string;

  constructor() {
    super();
    this.products = this.$root.$data.products;
    this.productToAdd = '1k8br3z9g';
    this.productSelected = {} as Product;
    this.showSnackbar = false;
    this.snackbarMessage = '';
  }

  enterProduct(): void {
    if (this.productToAdd.length === 0) {
      this.showSnackbar = true;
      this.snackbarMessage = 'Enter product code.';
    } else {
      const searchProduct = this.products.filter((x) => x.productCode === this.productToAdd);
      if (searchProduct.length > 0) {
        [this.productSelected] = searchProduct;
        this.productSelected.quantity = 1;
        setTimeout(() => {
          ((this.$refs.prodQuantity as Vue).$el as HTMLElement).focus();
        }, 200);
      }
    }
  }

  newTransaction(): void {
    ((this.$refs.productInput as Vue).$el as HTMLElement).focus();
  }
}
